/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Image, Modal } from "react-bootstrap";
import "./modal.scss";
import {
  getTransactionUrl,
  getTruncatedAddress,
  status as statusType,
} from "utils/helper";
import { useRootContext } from "context/app-context";

const StakeModal = ({ show, onHide, title, status, t_hash }) => {
  const { selectedNetwork } = useRootContext();

  useEffect(() => {
    if (status === statusType.SUCCESS) {
      let timeout = setTimeout(() => {
        onHide();
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [status]);

  return (
    <Modal
      show={show}
      size="xsm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-light"
    >
      <Modal.Header>
        <button className="close-btn" onClick={onHide}>
          <Image
            src={process.env.REACT_APP_S3_IMAGE_PATH + "cross.svg"}
            fluid
          />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-title text-center">
          <h4>{title}</h4>
        </div>
        <div className="icon-center">
          {status === statusType.PENDING && (
            <div className="icon-wrapper exclude">
              <Image
                src={process.env.REACT_APP_S3_IMAGE_PATH + "excludeIcon.svg"}
                fluid
              />
            </div>
          )}
          {status === statusType.SUCCESS && (
            <div className="icon-wrapper success">
              <Image
                src={process.env.REACT_APP_S3_IMAGE_PATH + "successIcon.svg"}
                fluid
              />
            </div>
          )}
          {status === statusType.FAIL && (
            <div className="icon-wrapper fail">
              <Image
                src={process.env.REACT_APP_S3_IMAGE_PATH + "fail.svg"}
                fluid
              />
            </div>
          )}
        </div>
        <div className="text-holder text-center mb-0">
          <div className="detail">
            <div className="info">
              Transaction ID:{" "}
              <a
                title={t_hash}
                href={getTransactionUrl(t_hash, selectedNetwork)}
                rel="noreferrer"
                className="address"
              >
                {getTruncatedAddress(t_hash)}
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StakeModal;
